import styled, { css, keyframes } from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { Z_INDEX } from '../utils'

// New wave animation for the pulsating effect
const waveAnimation = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.2;
  }
  100% {
    transform: scale(3);
    opacity: 0;
  }
`

const pulseDot = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
`

export const Wrapper = styled.div<{ disablePulse?: boolean }>`
  position: fixed;
  width: 54px;
  height: 54px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;
  z-index: ${Z_INDEX + 1};

  ${props =>
    props.disablePulse &&
    css`
      width: 12px;
      height: 12px;
      background: none;
    `}
`

export const Dot = styled.span`
  width: 12px;
  height: 12px;
  background: ${Colors.Blue50};
  border: 1.4px solid ${Colors.White};
  border-radius: 50%;
  z-index: ${Z_INDEX + 1};
  animation: ${pulseDot} 1.5s ease-in-out infinite;
`

export const Wave = styled.div<{ delay: string }>`
  position: absolute;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: ${Colors.Blue50};
  opacity: 0;
  z-index: 1;

  animation: ${waveAnimation} 2.4s infinite cubic-bezier(0.3, 0, 0.7, 1);
  animation-delay: ${props => props.delay};
`
